module.exports = __webpack_public_path__ + "img/1-03.d5afb72a.png";